var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"cn-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"},domProps:{"innerHTML":_vm._s(_setup.icons[_vm.name])}})
}
var staticRenderFns = []

export { render, staticRenderFns }